/* src/app/core/components/initials/initials.component.scss */
/*# sourceMappingURL=initials.component.css.map */
